import type { FieldPolicy, Reference } from "@apollo/client"

export const getObjectTags: FieldPolicy = {
  merge(_, incoming: Reference[]) {
    return incoming
  }
}
